import { useCustomImage } from "../../hooks";
import classes from "../../styles/History.module.css";
import { getClasses, transpose, history } from "../../utils";

export const EMPTY_TILE_ID = 0;
const Tile: React.FC<{
  highlighted: boolean;
  muted: boolean;
  id: number | "string";
}> = ({ highlighted, muted, id }) => {
  let _id;
  let multiplier;

  if (typeof id === "string" && id.includes("x")) {
    const split = id.split("x");
    _id = split[0];
    multiplier = <div className={classes["tile-multiplier"]}>x{split[1]}</div>;
  } else {
    _id = id;
    multiplier = null;
  }

  const highlightedC = highlighted ? "highlighted" : "";
  const seletedC = muted ? "muted" : "";
  const src = useCustomImage(`symbols/${_id}.png`);

  if (_id === EMPTY_TILE_ID) return <div className={classes.empty}></div>;

  return (
    <div className={getClasses(classes, "tile", highlightedC, seletedC)}>
      <img alt={`symbol ${id}`} src={src} />
      {multiplier}
    </div>
  );
};

type Tiles = number[];

const Slot: React.FC<{ view: Tiles[]; highlighted: Tiles; muted: Tiles }> = ({
  view,
  highlighted,
  muted,
}) => {
  const width = view.length;
  const height = view[0].length;
  const transposeIndex = history.transposeIndex.bind(null, width, height);

  return (
    <div className={classes.slot}>
      <div
        className={classes.reels}
        style={{ gridTemplateColumns: `repeat(${width}, auto)` }}
      >
        {transpose(view)
          .flat()
          .map((id: number, i: number) => {
            return (
              <Tile
                key={`tile-${i}`}
                id={id}
                highlighted={highlighted.includes(transposeIndex(i))}
                muted={muted.includes(transposeIndex(i))}
              />
            );
          })}
      </div>
    </div>
  );
};

export default Slot;
